import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDialog-paper": {
      width: "400px",
      borderRadius: "12px",
    },
  },
  dialogTitleContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontWeight: "bold",
  },
  closeIcon: {
    cursor: "pointer",
  },
  vehicleInfoContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "20px",
  },
  vehicleImage: {
    width: "120px",
    height: "90px",
    objectFit: "cover",
    borderRadius: "8px",
    border: "1px solid #ddd",
    marginBottom: "10px",
  },
  noImageWrapper: {
    width: "120px",
    height: "90px",
    borderRadius: "8px",
    border: "1px solid #ddd",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "10px",
    backgroundColor: "#f5f5f5",
  },
  vehicleNo: {
    fontWeight: "600",
    fontSize: "1.2rem",
    backgroundColor: "#fff0b3",
    padding: "4px 12px",
    borderRadius: "4px",
    border: "1px solid #e6c300",
  },
  textFieldWrapper: {
    marginTop: "10px",
    marginBottom: "20px",
  },
  sbtBtnWrapper: {
    display: "flex",
    justifyContent: "center",
  },
  dialogActions: {
    padding: "10px",
  },
}));

export default useStyles;
